/**
 * InvestorProtectedRoute - Investor role guard
 *
 * Protects hub routes - only investors can access.
 * Non-investors are redirected to the main dashboard.
 */

import { useContext } from "react";
import { Navigate } from "react-router-dom";
import { AuthContext } from "@/contexts/AuthContext";

interface InvestorProtectedRouteProps {
  children: React.ReactNode;
}

export const InvestorProtectedRoute: React.FC<InvestorProtectedRouteProps> = ({ children }) => {
  const authContext = useContext(AuthContext);

  if (!authContext) {
    throw new Error("InvestorProtectedRoute must be used within AuthProvider");
  }

  // ProtectedRoute handles the unauthenticated case, but belt-and-suspenders
  if (!authContext.isAuthenticated) {
    return null;
  }

  if (!authContext.tokenManagement.isInvestor()) {
    return <Navigate to="/" replace />;
  }

  return <>{children}</>;
};
